<app-features-container
  header="{{ '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.TITLE' | translate }}"
  [overlayType]="availableOverlays.ViCarePlans"
  *ngIf="plans"
>
  <div feature notDraggableContent class="plan plan--full" *ngFor="let plan of plans">
    <div class="plan__title" ViEllipsis [includeHeight]="true" [showTextContentInTooltip]="true">
      {{
        '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.' + plan.plan + '.TITLE' | uppercase | translate
      }}
    </div>
    <div class="plan__description">
      <p ViEllipsis [includeHeight]="true" [showTextContentInTooltip]="true">
        {{
          '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.' + plan.plan + '.DESCRIPTION'
            | uppercase
            | translate
        }}
      </p>
    </div>
    <div class="plan__footer">
      <app-pill [type]="plan.active ? pillType.bright : pillType.dark">
        {{
          (plan.isDefault
            ? '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.ACTIVE'
            : plan.active
            ? '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.ACTIVE'
            : '+INSTALLATIONS.INSTALLATION.VICARE_PLANS.INACTIVE'
          ) | translate
        }}
      </app-pill>
    </div>
  </div>
</app-features-container>
